export default __webpack_public_path__ + "static/media/novembazar_raffle_standard.860b3d7f.png";